export {default as icons} from './incident_step_icons.js'

export {default as details} from './incident_step_details.js'

export const steps = ["reported", "acknowledged", "discussed", "investigated"]